/**
 * @generated SignedSource<<d991e3f86cbf16f1585936aaa341cfdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateScheduleInput = {
  clientMutationId?: string | null;
  scheduleId: string;
  startTime?: string | null;
  endTime?: string | null;
};
export type ScheduleEditFormContainer_Mutation$variables = {
  input: UpdateScheduleInput;
};
export type ScheduleEditFormContainer_MutationVariables = ScheduleEditFormContainer_Mutation$variables;
export type ScheduleEditFormContainer_Mutation$data = {
  readonly updateSchedule: {
    readonly schedule: {
      readonly id: string;
      readonly slug: string;
      readonly startTime: string | null;
      readonly endTime: string | null;
    } | null;
  } | null;
};
export type ScheduleEditFormContainer_MutationResponse = ScheduleEditFormContainer_Mutation$data;
export type ScheduleEditFormContainer_Mutation = {
  variables: ScheduleEditFormContainer_MutationVariables;
  response: ScheduleEditFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSchedulePayload",
    "kind": "LinkedField",
    "name": "updateSchedule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Schedule",
        "kind": "LinkedField",
        "name": "schedule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endTime",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleEditFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScheduleEditFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b98f99ff3f26b35f8fe009b9ec7a091e",
    "id": null,
    "metadata": {},
    "name": "ScheduleEditFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ScheduleEditFormContainer_Mutation(\n  $input: UpdateScheduleInput!\n) {\n  updateSchedule(input: $input) {\n    schedule {\n      id\n      slug\n      startTime\n      endTime\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b2a5ec5e932fad2f570eed49037db42";

export default node;
